import { useMemo } from "react";


type TMonthDay = {
    date: Date,
    class?: "current" | "opacity",
}

type TMonthWeek = TMonthDay[]

const toRuWeekDay = (date: number) => (date + 6) % 7

export const useGetMonthWeeks = (visibleMonth: Date): TMonthWeek[] => {
    const monthWeeks = useMemo(() => {
        const currentDate = new Date()
        const date = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth(), 1)

        const checkCurrentMonth = (dayDate: Date) => {
            return dayDate.getMonth() === currentDate.getMonth() &&
                dayDate.getFullYear() === currentDate.getFullYear()
        }

        const days: TMonthDay[] = []

        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

        const firstDate = toRuWeekDay(firstDay.getDay())

        const firstWeekDayPrevMonth = new Date(date.getFullYear(), date.getMonth(), 1 - firstDate)
        const lastWeekDay = toRuWeekDay(lastDay.getDay())

        for(let i = 0; i < firstDate; i++){
            days.push({
                date: new Date(
                    firstWeekDayPrevMonth.getFullYear(),
                    firstWeekDayPrevMonth.getMonth(),
                    firstWeekDayPrevMonth.getDate() + i
                ),
                class: 'opacity'
            })
        }
        for(let i = 1; i <= lastDay.getDate(); i++){
            const dayDate = new Date(date.getFullYear(), date.getMonth(), i)

            days.push({
                date: dayDate,
                class: (i === currentDate.getDate() && checkCurrentMonth(dayDate)) ? 'current' : undefined
            })
        }
        for(let i = 1; i < 7 - lastWeekDay; i++){
            days.push({
                date: new Date(date.getFullYear(), date.getMonth() + 1, i),
                class: 'opacity'
            })
        }

        const weeks: TMonthWeek[] = []

        for(let weekIndex = 0; weekIndex < days.length; weekIndex += 7){
            const week: TMonthWeek = []

            for(let dayIndex = weekIndex; dayIndex < weekIndex + 7; dayIndex++){
                if(days[dayIndex]) week.push(days[dayIndex])
            }

            weeks.push(week)
        }

        return weeks
    }, [visibleMonth])

    return monthWeeks
}